import Accordion from "@components/BasicComponents/Accordion/Accordion"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {splitArrayIntoTwoEqualParts} from "@helpers/splitArrayIntoTwoEqualParts"
import {FAQModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./OverviewFAQSection.module.scss"

type Props = {
	faq: FAQModuleType[]
}

const OverviewFAQSection = (props: Props) => {
	const [firstPart, secondPart] = splitArrayIntoTwoEqualParts(props.faq)

	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<Title
						content={"Frequently Asked Questions"}
						fontWeight={600}
						size={"XL"}
						center
					/>
					<Separator />
					<div className={styles.cardContainer}>
						<div className={styles.cardBox}>
							<Accordion items={firstPart} />
						</div>
						<div className={styles.cardBox}>
							<Accordion items={secondPart} />
						</div>
					</div>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default OverviewFAQSection
